import {
  CREATE_STORY,
  CREATE_STORY_COMPLETE,
  FETCH_STORY,
  FETCH_STORY_FAILED,
  FETCH_STORY_SUCCESS,

  FETCH_SINGLE_STORY,
  FETCH_SINGLE_STORY_COMPLETE,
  FETCH_SINGLE_STORY_FAILED,
} from "./types";
import reduceArray from "../../utils/reduceArray";

export const initialState = {
  fetchingStory: false,
  fetchingStories: false,
  submittingStories: false,
  currentUserStories: [],
  creatingStory: false,
  mappedStoriesToId: {},
  mappdedStoriesToSlug: {},
  allStories: {},
};

export const storiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STORY:
      return {
        ...state,
        creatingStory: true,
      };
    case CREATE_STORY_COMPLETE:
      return {
        ...state,
        creatingStory: false,
      };
    case FETCH_STORY:
      return {
        ...state,
        fetchingStories: true,
      };
    case FETCH_STORY_FAILED:
      return {
        ...state,
        fetchingStories: false,
      };
    case FETCH_STORY_SUCCESS:
      return {
        ...state,
        fetchingStories: false,
        allStories: action?.stories,
        mappedStoriesToId: reduceArray(action?.stories?.data, "id"),
      };
    case FETCH_SINGLE_STORY: return {
      ...state,
      fetchingStory: true,
    };
    case FETCH_SINGLE_STORY_COMPLETE: return {
      ...state,
      fetchingStory: false,
      mappedStoriesToId: {
        [action?.story?.id]: action?.story,
        ...state?.mappedStoriesToId
      },
      mappedStoriesToSlug: {
        [action?.story?.slug]: action?.story,
        ...state?.mappedStoriesToSlug
      }
    };
    case FETCH_SINGLE_STORY_FAILED: return {
      ...state,
      fetchingStory: false,
    }
    default:
      return state;
  }
};
